// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"324ac73a","453":"5c5e1b6a"}[chunkId] + ".chunk.js";
};